/**
 * Learn more about light and dark modes:
 * https://docs.expo.dev/guides/color-schemes/
 */

import { useColorScheme } from 'react-native';

import { ExpoTemplateColors } from '@/constants/ExpoTemplateColors';

export function useThemeColor(
  props: { light?: string; dark?: string },
  colorName: keyof typeof ExpoTemplateColors.light &
    keyof typeof ExpoTemplateColors.dark,
) {
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const colorFromProps = props[theme];

  if (colorFromProps) {
    return colorFromProps;
  } else {
    return ExpoTemplateColors[theme][colorName];
  }
}
